export const getSelectorStyles = (width: number) => {
    return {
        control: (provided: any, state: any) => ({
            ...provided,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            borderColor: "#8C96A1",
            borderRadius: "8px",
            boxSizing: "border-box",
            height: "48px",
            minHeight: "48px",
            width: `${width}px`,
            minWidth: `${width}px`,
            maxWidth: `${width}px`,
            padding: "0 8px",
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: "transparent",
            "&:hover": {borderColor: "#A0A2A5"},
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            padding: '0 4px',
            gap: '4px',

            // custom scrollbar
            scrollbarWidth: 'thin',
            scrollbarColor: '#A0A2A5 transparent',
            '&::-webkit-scrollbar': {
                height: '2px',
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#A0A2A5',
                borderRadius: '8px',
            },
        }),
        multiValue: (provided: any) => ({
            ...provided,
            backgroundColor: 'white',
            flex: '0 0 auto',
        }),
        multiValueLabel: (provided: any) => ({
            ...provided,
            fontSize: 14,
            color: 'black',
            padding: '2px 6px',
        }),
        multiValueRemove: (provided: any) => ({
            ...provided,
            cursor: 'pointer',
            color: '#8C96A1',
            ':hover': {
                backgroundColor: '#ccc',
                color: 'black',
            },
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            color: state.isDisabled ? "var(--text-disabled)" : "var(--text-black)",
            fontSize: "16px",
            fontWeight: 400,
        }),
        indicatorSeparator: (provided: any) => ({
            ...provided,
            backgroundColor: 'transparent',
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            color: '#A0A2A5',
            cursor: 'pointer',
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
            transitionDuration: "300ms",
            transitionProperty: "transform",
            pointerEvents: 'none',
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: 16,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            backgroundColor: state.isSelected ? 'var(--gold)' : state.isFocused ? 'var(--light-gold)' : 'var(--white)',
            color: 'var(--text-black)',
            '&:hover': {
                backgroundColor: state.isSelected ? 'var(--gold)' : state.isFocused ? 'var(--light-gold)' : 'var(--white)',
            }
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: 999999
        })
    }
}
